<template>
  <div>
    <faq-usage v-if="showFaqsUsage" />

    <v-tabs
      :key="$i18n.locale"
      v-model="tab"
      class="mb-4"
      @change="handleTabsChange"
    >
      <v-tab
        key="list"
        href="#list"
        :disabled="faqs.length === 0"
      >
        {{ $t('Team FAQs') }}
      </v-tab>
      <v-tab
        key="create"
        href="#create"
      >
        {{ $t('Create new FAQ') }}
      </v-tab>
    </v-tabs>

    <div v-if="tab === 'list'">
      <faq-card
        v-for="faq in faqs"
        :key="faq.uuid"
        class="mb-6"
        :faq="faq"
        @click="$inertia.visit(route('faq.manage', faq.id))"
      />
    </div>

    <create-faq-form
      v-else-if="tab === 'create'"
      :available-languages="availableLanguages"
      :num-faqs="faqs.length"
    />
  </div>
</template>

<script>
import FaqCard from '@/components/faq/FaqCard';
import CreateFaqForm from '@/components/faq/CreateFaqForm';
import Layout from '@/components/shared/TheLayout';

export default {
  components: {
    FaqCard,
    CreateFaqForm
  },

  layout: (h, page) => h(Layout, {
    props: {
      pageTitle: page.data.props.pageTitle
    }
  }, [page]),

  props: {
    faqs: {
      type: [Object, Array],
      required: false,
      default: () => {}
    },
    availableLanguages: {
      type: Array,
      required: false,
      default: () => []
    },
    activeTab: {
      type: String,
      required: true,
    },
    showFaqsUsage: {
      type: Boolean
    }
  },

  data() {
    return {
      tab: this.activeTab,
    }
  },

  mounted() {
    this.setTabFromHash();
  },

  methods: {
    setTabFromHash() {
      let hash = window.location.hash;
      if (hash) {
        const tab = hash.replace('#', '');
        if (tab === 'create' || tab === 'list') {
          this.tab = tab;
        }
      }
    },

    handleTabsChange(tab) {
      history.pushState(null, null, `#${tab}`);
    }
  }
}
</script>